import { TEt3CustomizedButton } from "../../TypesNEW";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import { colors } from "../et3-theme/colors";

const Et3CustomizedButton = withLiteObserverAndTheme<TEt3CustomizedButton>(
  (props) => {
    const {
      children = null,
      width,
      height,
      fDirection,
      color,
      style,
      theme,
      alignItems,
      justifyContent,
      withShadow,
      onClick,
      isEnabled
    } = props;
    const { unitX, unitY, shadow } = theme;

    let divStyle = {
      display: "flex",
      flexDirection: fDirection,
      alignItems: alignItems,
      justifyContent: justifyContent,
      minHeight: height * unitY,
      minWidth: width * unitX,
      height: height * unitY,
      width: width * unitX,
      backgroundColor: color,
      border: `0px solid ${colors.all.transparent}`,
      ...style
    };
    if (withShadow) {
      divStyle = { ...divStyle, ...shadow };
    }
    return (
      <button
        className="clickable"
        onClick={() => onClick()}
        style={divStyle}
        disabled={!isEnabled}
      >
        {children}
      </button>
    );
  }
);
export default Et3CustomizedButton;
